import React from 'react';
import CompMarquee from '../Components/CompMarquee';
import './CXMainStreet.css'; // Import the CSS file
import CompContentBlock from '../Components/CompContentBlock';
import { Grid, Card, CardContent } from '@mui/material'; // Import Material-UI components
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Import Material-UI CheckCircle icon
import CompContactWidget from '../Components/CompContactWidget';
import CXMainStreetImg1 from '../Assets/Images/uxi-2025-cx-main-feature1.png';
import CXMainStreetSubImg1 from '../Assets/Images/uxi-2025-cx-main-subfeature1.png';
import CXMainStreetSubImg2 from '../Assets/Images/uxi-2025-cx-main-subfeature2.png';
import CXMainStreetSubImg3 from '../Assets/Images/uxi-2025-cx-main-subfeature3.png';

function CXMainStreet() {
  return (
    <div className="consulting-container">
      <CompMarquee title="User-centered AI for Small Businesses" subTitle="AI that is visible, practical and understandable." />
      <CompContentBlock heading="AI with a Small Business Focus" subheading="We have over 15 years of designing the best user experiences and are now using that personalized approach to design AI for small business.">
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <img src={CXMainStreetImg1} alt="How Many Hats Can You Give to AI?" style={{ width: '100%' }} />
          </Grid>
          <Grid item xs={12} md={8}>
            <h4>How Many Hats Can You Give to AI?</h4>
            <p>
            Running a small business means wearing many hats — marketing, customer service, operations, and more.
            CX Mainstreet gives you AI-driven tools to streamline your customer experience (CX), marketing, and operations — so you can focus on growing your business.
            </p>
            <ul style={{ listStyleType: 'none', padding: 0 }}>
              <li><CheckCircleIcon style={{ marginRight: '8px' }} />Save Time</li>
              <li><CheckCircleIcon style={{ marginRight: '8px' }} />Engage Customers 24/7</li>
              <li><CheckCircleIcon style={{ marginRight: '8px' }} />Boost Revenue</li>
              <li><CheckCircleIcon style={{ marginRight: '8px' }} />Stay Competitive</li>
            </ul>
          </Grid>
        </Grid>
      </CompContentBlock>
      <CompContentBlock heading="AI-Powered Focus Areas" subheading="These are some examples of AI-driven focus areas designed to help your business thrive.">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={4}>
            <Card style={{ minHeight: '310px' }}>
              <CardContent>
                <h5>AI Customer Support</h5>
                <p>
                  Automated chatbots and email responders that deliver fast, friendly answers.
                </p>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Card style={{ minHeight: '310px' }}>
              <CardContent>
                <h5>Smart Marketing Tools</h5>
                <p>
                  Create campaigns, generate social media posts, and write blog articles — all with a few clicks.
                </p>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Card style={{ minHeight: '310px' }}>
              <CardContent>
                <h5>Insights Dashboards</h5>
                <p>
                  Visualize customer behavior, satisfaction, and feedback in real time.
                </p>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Card style={{ minHeight: '310px' }}>
              <CardContent>
                <h5>Administration Optimization</h5>
                <p>
                  Monitor reviews, respond automatically, and request feedback at the right moments.
                </p>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Card style={{ minHeight: '310px' }}>
              <CardContent>
                <h5>Customer Facing Automation</h5>
                <p>
                  Let customers schedule, order, or check on services without manual follow-up.
                </p>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Card style={{ minHeight: '310px' }}>
              <CardContent>
                <h5>And More!</h5>
                <p>
                  Offer customers smart upsells or follow-up services based on their past interactions.
                </p>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </CompContentBlock>
      <CompContentBlock heading="Use our platform and add tailored features!" subheading="">
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <img src={CXMainStreetSubImg1} alt="Core platform" style={{ width: '100%' }} />
            <h5 style={{ marginTop: '10px' }}>Core Platform</h5>
            <p>
              Our core platform provides essential tools to streamline your business operations and enhance customer experiences.
            </p>
          </Grid>
          <Grid item xs={12} md={4}>
            <img src={CXMainStreetSubImg2} alt="Core platform" style={{ width: '100%' }} />
            <h5 style={{ marginTop: '10px' }}>Peace of Mind AI</h5>
            <p>
              Use whatever AI services you want, or let us help you find the right ones for your business.
            </p>
          </Grid>
          <Grid item xs={12} md={4}>
            <img src={CXMainStreetSubImg3} alt="Add-on Tools" style={{ width: '100%' }} />
            <h5 style={{ marginTop: '10px' }}>Add-on Tools</h5>
            <p>
              Customize your experience with add-on tools designed to meet the unique needs of your business.
            </p>
          </Grid>
        </Grid>
      </CompContentBlock>
      <CompContentBlock heading="Pricing Plans" subheading="Choose the plan that fits your business needs.">
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Card style={{ minHeight: '250px' }}>
              <CardContent>
                <h5>Single Stack</h5>
                <h5><strong>Starts at Only $99/month</strong></h5>
                <p>Perfect for small businesses looking to get started with AI tools.</p>
                <ul style={{ listStyleType: 'none', padding: 0 }}>
                  <li><CheckCircleIcon style={{ marginRight: '8px' }} />Access to core platform</li>
                  <li><CheckCircleIcon style={{ marginRight: '8px' }} />Hand selected AI tools for your use case</li>
                  <li><CheckCircleIcon style={{ marginRight: '8px' }} />Email support and custom onboarding</li>
                </ul>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card style={{ minHeight: '250px' }}>
              <CardContent>
                <h5>Custom Stack</h5>
                <h5><strong>Contact us for pricing</strong></h5>
                <p>Tailored solutions for businesses with unique needs.</p>
                <ul style={{ listStyleType: 'none', padding: 0 }}>
                  <li><CheckCircleIcon style={{ marginRight: '8px' }} />Customized AI tools</li>
                  <li><CheckCircleIcon style={{ marginRight: '8px' }} />Dedicated account manager</li>
                  <li><CheckCircleIcon style={{ marginRight: '8px' }} />Priority support</li>
                </ul>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </CompContentBlock>
      <CompContactWidget />
    </div>
  );
}

export default CXMainStreet;
